import { createFrontOfficeInstance } from '@/shared/api/api-instance';

export type AiProviderNameDto = 'mock' | 'openai' | 'anthropic' | 'deepseek' | 'gemini';

export type AiProviderSettingsDto = {
  provider: AiProviderNameDto;
  model: string;
  base_url: string | null;
  configured: boolean;
  api_key_hint: string | null;
  updated_at: string | null;
};

export type UpdateAiProviderSettingsRequestDto = {
  provider: AiProviderNameDto;
  model?: string;
  base_url?: string;
  api_key?: string;
};

export const getAiProviderSettings = () =>
  createFrontOfficeInstance<AiProviderSettingsDto>({
    url: '/api/v1/ai/provider-settings',
    method: 'GET',
  });

export const updateAiProviderSettings = (
  data: UpdateAiProviderSettingsRequestDto
) =>
  createFrontOfficeInstance<AiProviderSettingsDto>({
    url: '/api/v1/ai/provider-settings',
    method: 'PUT',
    data,
  });
